import html_default from "./template.default.html?raw";
const app_theme = import.meta.env.VITE_APP_THEME;
let html = "";
if ("default" == app_theme) {
  html = html_default;
}
import { inject, ref, computed, onMounted, onUnmounted } from "vue";
import type { UserService } from "../../application/services/UserService.ts";
import type { WhoamiDto } from "../../shared/WhoamiDto.ts";
import LoginCode from "../LoginCode/index.ts";

// Login-Leiste (z. B. Videoseite): "Anmelden" oeffnet die Code-Maske, eingeloggt: Name und Abmelden.
// Der Heartbeat prueft regelmaessig, ob das Token noch gilt, und erneuert es bei Bedarf (nur hier, nicht in anderen Komponenten).
export default {
  template: html,
  components: { LoginCode },
  setup() {
    const error = ref("");
    const showLogin = ref(false);
    const userService: UserService | undefined = inject("userService");
    const whoami = ref<WhoamiDto | null>(null);

    let heartbeatInterval: number | undefined;

    const runHeartbeat = async () => {
      try {
        if (userService) {
          whoami.value = await userService.getUserInfo();
        }
      } catch (err) {
        console.error("Heartbeat failed", err);
      }
    };

    const isLoggedIn = computed(() => whoami.value?.isLoggedIn ?? false);
    const mandantName = computed(() => whoami.value?.mandantName ?? "");
    const customerName = computed(() => whoami.value?.customerName ?? "");

    const onLoggedIn = async function () {
      showLogin.value = false;
      await runHeartbeat();
      // Andere Komponenten auf der Seite (Videos) pruefen den Login selbst per Heartbeat; ein Reload macht es sofort sichtbar
      location.reload();
    };

    const doLogout = async function () {
      if (userService) {
        const url = await userService.getLogoutUrl();
        userService.logout();
        location.href = url;
      }
    };

    onMounted(async () => {
      if (userService) {
        whoami.value = await userService.getUserInfo();
        heartbeatInterval = window.setInterval(runHeartbeat, 60000);
      }
    });
    onUnmounted(() => {
      if (heartbeatInterval) {
        clearInterval(heartbeatInterval);
      }
    });

    return {
      showLogin,
      onLoggedIn,
      doLogout,
      error,
      mandantName,
      customerName,
      isLoggedIn,
    };
  },
};
